// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h7-a";
export var fulfillmentFormRail = "_h7-9";
export var headerTitleRow = "_h7-c";
export var orderDetailsWrapper = "_h7-7";
export var orderLinkTrigger = "_h7-2";
export var paymentInformationGrid = "_h7-h";
export var paymentSummaryColumn = "_h7-i";
export var shipmentContainer = "_h7-b";
export var shipmentDetailsMainPane = "_h7-8";
export var shipmentNavigationCard = "_h7-5";
export var shipmentNavigationRail = "_h7-3";
export var shipmentNavigationRailHeader = "_h7-4";
export var shipmentSummaryFact = "_h7-e";
export var shipmentSummaryGrid = "_h7-d";
export var shipmentSummaryMetadataRow = "_h7-f";
export var shipmentSummaryTags = "_h7-g";
export var shipmentWorkspace = "_h7-0";
export var shipmentWorkspaceContent = "_h7-6";
export var shipmentWorkspaceHeader = "_h7-1";